import React, { useState } from 'react';
import axios from 'axios';
import './App.css';

const SHELBY_QUOTES = [
  "You had the cards. You folded.",
  "A Shelby never misses a deal. You are not a Shelby.",
  "Tommy would have pulled the trigger. You didn't.",
  "In this family, we don't miss opportunities. You did.",
  "You had the intel. You sat on it like a coward.",
  "Every Peaky Blinder knows — hesitation is poverty.",
  "You looked at the board. You blinked. Now look at what it cost you.",
  "By order of the Peaky Blinders — you bottled it.",
];

const COINS = [
  { id: 'bitcoin', name: 'Bitcoin (BTC)' },
  { id: 'ethereum', name: 'Ethereum (ETH)' },
  { id: 'dogecoin', name: 'Dogecoin (DOGE)' },
  { id: 'solana', name: 'Solana (SOL)' },
  { id: 'ripple', name: 'XRP' },
  { id: 'matic-network', name: 'Polygon (MATIC)' },
  { id: 'cardano', name: 'Cardano (ADA)' },
  { id: 'shiba-inu', name: 'Shiba Inu (SHIB)' },
];

function App() {
  const [coin, setCoin] = useState('bitcoin');
  const [amount, setAmount] = useState('');
  const [date, setDate] = useState('');
  const [currency, setCurrency] = useState('usd');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const currencySymbol = currency === 'inr' ? '₹' : '$';

  const calculate = async () => {
    if (!amount || !date) {
      setError('Fill in all fields, soldier.');
      return;
    }
    setError('');
    setLoading(true);
    setResult(null);
    try {
      const dateObj = new Date(date);
      const formatted = `${String(dateObj.getDate()).padStart(2,'0')}-${String(dateObj.getMonth()+1).padStart(2,'0')}-${dateObj.getFullYear()}`;

      const histRes = await axios.get(`https://fomo-finance-backend.onrender.com/history`, {
        params: { coin, date: formatted, currency }
      });
      const histPrice = histRes.data.price;

      const nowRes = await axios.get(`https://fomo-finance-backend.onrender.com/price`, {
        params: { coin, currency }
      });
      const nowPrice = nowRes.data.price;

      const coins = parseFloat(amount) / histPrice;
      const worthNow = coins * nowPrice;
      const diff = worthNow - parseFloat(amount);
      const multiplier = (worthNow / parseFloat(amount)).toFixed(2);
      const quote = SHELBY_QUOTES[Math.floor(Math.random() * SHELBY_QUOTES.length)];
      setResult({ histPrice, nowPrice, coins, worthNow, diff, multiplier, quote });
    } catch (e) {
      setError('Failed to fetch data. Try a more recent date.');
    }
    setLoading(false);
  };

  return (
    <div className="app">
      <div className="header">
        <div className="crest">⚜️</div>
        <h1 className="title">FOMO.FINANCE</h1>
        <p className="subtitle">BY ORDER OF THE PEAKY BLINDERS</p>
        <div className="divider"></div>
        <p className="tagline">You planned the heist. You never showed up.</p>
      </div>

      <div className="card">
        <div className="field">
          <label>CHOOSE YOUR ASSET</label>
          <select value={coin} onChange={e => setCoin(e.target.value)}>
            {COINS.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>

        <div className="field">
          <label>CURRENCY</label>
          <select value={currency} onChange={e => setCurrency(e.target.value)}>
            <option value="usd">US Dollar ($)</option>
            <option value="inr">Indian Rupee (₹)</option>
          </select>
        </div>

        <div className="field">
          <label>AMOUNT YOU "ALMOST" INVESTED</label>
          <input
            type="number"
            placeholder={`${currencySymbol}10,000`}
            value={amount}
            onChange={e => setAmount(e.target.value)}
          />
        </div>

        <div className="field">
          <label>DATE YOU CHICKENED OUT</label>
          <input
            type="date"
            value={date}
            onChange={e => setDate(e.target.value)}
            min="2015-01-01"
            max={new Date().toISOString().split('T')[0]}
          />
        </div>

        {error && <p className="error">{error}</p>}

        <button className="btn" onClick={calculate} disabled={loading}>
          {loading ? 'CALCULATING YOUR REGRET...' : 'CALCULATE THE DAMAGE ⚔️'}
        </button>
      </div>

      {result && (
        <div className="result-card">
          <div className="crest">💀</div>
          <p className="result-quote">"{result.quote}"</p>
          <div className="divider"></div>

          <div className="stat-row">
            <span>YOU INVESTED</span>
            <span className="gold">{currencySymbol}{parseFloat(amount).toLocaleString()}</span>
          </div>
          <div className="stat-row">
            <span>PRICE THEN</span>
            <span>{currencySymbol}{result.histPrice.toLocaleString()}</span>
          </div>
          <div className="stat-row">
            <span>PRICE NOW</span>
            <span>{currencySymbol}{result.nowPrice.toLocaleString()}</span>
          </div>
          <div className="stat-row">
            <span>COINS YOU'D HAVE</span>
            <span>{result.coins.toFixed(6)}</span>
          </div>

          <div className="divider"></div>

          <div className="big-stat">
            <p>WORTH TODAY</p>
            <h2 className={result.diff >= 0 ? 'profit' : 'loss'}>
              {currencySymbol}{result.worthNow.toLocaleString(undefined, {maximumFractionDigits: 0})}
            </h2>
          </div>

          <div className={`verdict ${result.diff >= 0 ? 'profit-box' : 'loss-box'}`}>
            {result.diff >= 0 ? (
              <>
                <p>YOU MISSED</p>
                <h3>{currencySymbol}{result.diff.toLocaleString(undefined, {maximumFractionDigits: 0})}</h3>
                <p>That's a {result.multiplier}x return. Gone. Forever.</p>
              </>
            ) : (
              <>
                <p>YOU ACTUALLY DODGED</p>
                <h3>{currencySymbol}{Math.abs(result.diff).toLocaleString(undefined, {maximumFractionDigits: 0})}</h3>
                <p>Even Shelby knows when to fold. Well played.</p>
              </>
            )}
          </div>

          <div className="affiliate">
            <p>Ready to stop missing? Start investing today 👇</p>
            <div className="aff-links">
              <a href="https://zerodha.com" target="_blank" rel="noreferrer" className="aff-btn">Zerodha</a>
              <a href="https://groww.in" target="_blank" rel="noreferrer" className="aff-btn">Groww</a>
              <a href="https://coindcx.com" target="_blank" rel="noreferrer" className="aff-btn">CoinDCX</a>
            </div>
          </div>
        </div>
      )}

      <footer>
        <p>⚜️ FOMO.FINANCE — By Order of the Peaky Blinders ⚜️</p>
      </footer>
    </div>
  );
}

export default App;
